import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=99a9ed40&scoped=true"
import script from "./Wrap.vue?vue&type=script&lang=js"
export * from "./Wrap.vue?vue&type=script&lang=js"
import style0 from "./Wrap.vue?vue&type=style&index=0&id=99a9ed40&prod&lang=scss&scoped=true"
import style1 from "./Wrap.vue?vue&type=style&index=1&id=99a9ed40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a9ed40",
  null
  
)

export default component.exports